import React, { Component } from "react";
import Typed from "react-typed";
import "./BannerBg.scss";
import "./Banner.scss";

//Bootstrap Components
import { Button } from "react-bootstrap";

class Banner extends Component {
	onPortafolio() {
		window.open("https://github.com/lopdam", "_blank");
	}
	onProfile() {
		window.open(
			"https://www.linkedin.com/in/dennys-lopez-damian-0a7a16114",
			"_blank"
		);
	}

	render() {
		return (
			// <div id="home" className="intro route bg-image " style={{backgroundImage: "url("+bigImage+")"}}>
			<React.Fragment>
				<div id="home" className="intro route bg-image background">
					<div id="stars" />
					<div id="stars2" />
					<div id="stars3" />

					<div className="top-container intro-content display-table">
						<div className="table-cell">
							<div className="container">
								<h1 className="intro-title mb-4">I am, Lopez Damian</h1>
								<p className="intro-subtitle">
									<span className="text-slider-items"></span>
									<strong className="text-slider">
										<Typed
											strings={[
												"Software Developer",
												"Web Developer",
												"Angular",
												"React JS",
												"Django",
												"Mobile Developer",
												"Android ",
												"Flutter",
												"iOS"
											]}
											typeSpeed={80}
											backDelay={1100}
											backSpeed={30}
											loop
										/>
									</strong>
								</p>

								<div className="btns">
									<Button
										className="btn-banner"
										variant="success"
										type="button"
										value="Input"
										onClick={this.onProfile}
									>
										Curriculum
									</Button>

									<Button
										className="btn-banner last"
										variant="outline-success"
										type="button"
										value="Input"
										onClick={this.onPortafolio}
									>
										Portafolio
									</Button>
								</div>
							</div>
						</div>
					</div>
				</div>

				<div className="curved-div">
					<div>
						<h1>I am a Software Developer</h1>
						<p>More about me...</p>
					</div>
					<svg viewBox="0 0 1440 319">
						<path
							fill="#fff"
							d="M0,32L48,80C96,128,192,224,288,224C384,224,480,128,576,90.7C672,53,768,75,864,96C960,117,1056,139,1152,149.3C1248,160,1344,160,1392,160L1440,160L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"
						></path>
					</svg>
				</div>
			</React.Fragment>
		);
	}
}

export default Banner;
